const ComponentLoader = ({className}) => {
  return (
   <div className={`flex items-center justify-center w-full h-[40vh] + ${className} bg-gray-300 rounded-sm  `}></div>

  )
}

export default ComponentLoader